import { Form } from "react-bootstrap";

const Mobile = ({ values, handleChange, touched, errors }) => {
    return (
        <>
            <Form.Group>
                <Form.Label className="required">Mobile</Form.Label>
                <Form.Control
                    name="mobile"
                    placeholder="Enter mobile number"
                    value={values.mobile}
                    onChange={handleChange}
                    maxLength="10"
                />
                {touched.mobile && errors.mobile && <Form.Text className="text-danger">{errors.mobile}</Form.Text>}
            </Form.Group>
        </>
    )
}

export default Mobile;